import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import { Email, Phone } from '../components/Svg';

// import components
import {
  DocsWrapper,
  DocsTitle,
  DocsContent,
  DocsDownload,
  DocLink,
  DocsContact,
  CardContainer,
  ContactCard,
  BackBar,
  BackButton,
} from '../components/Base';

const Builder = ({ data }) => {
  const mapDocs = data => {
    return data.map(datum => {
      const { name, link, type } = datum.node;
      return (
        <DocLink
          key={name}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className={type} />
          {name}
        </DocLink>
      );
    });
  };

  const mapContacts = data => {
    return data.map(datum => {
      const { name, title, nmls, email, phone } = datum.node;

      return (
        <ContactCard key={name}>
          <h3>{name}</h3>
          <p>{title}</p>
          {nmls ? <p>{`NMLS #: ${nmls}`}</p> : null}
          <a href={`mailto:${email}`}>
            <Email />
            {`EMAIL ${name}`}
          </a>
          <a href={`tel:${phone}`}>
            <Phone />
            {`CALL ${phone}`}
          </a>
        </ContactCard>
      );
    });
  };

  return (
    <Layout>
      <DocsWrapper id="reach-skip-nav">
        <DocsTitle>
          <strong>Builder and Manufacturer</strong> Resources
        </DocsTitle>
        <DocsContent>
          <DocsDownload>
            <h2>Documents Download</h2>
            {mapDocs(data.allBuilderDocsJson.edges)}
          </DocsDownload>
          <DocsContact>
            <h2>Contacts</h2>
            <CardContainer>
              {mapContacts(data.allBuilderContactsJson.edges)}
            </CardContainer>
          </DocsContact>
        </DocsContent>
        <BackBar>
          <BackButton to="/">Back</BackButton>
        </BackBar>
      </DocsWrapper>
    </Layout>
  );
};

export default Builder;

export const query = graphql`
  {
    allBuilderDocsJson {
      edges {
        node {
          name
          link
          type
        }
      }
    }

    allBuilderContactsJson {
      edges {
        node {
          name
          title
          nmls
          email
          phone
        }
      }
    }
  }
`;
